export function handleSleighMovement(keysPressed, sleighObject, deltaTime) {
    if (!sleighObject) return;

    // Direct movement 
    let speed = 3 * deltaTime; 
    if (keysPressed['w'] || keysPressed['z']) sleighObject.position.y += speed;
    if (keysPressed['s']) sleighObject.position.y -= speed;
    if (keysPressed['a'] || keysPressed['q']) sleighObject.position.x -= speed;
    if (keysPressed['d']) sleighObject.position.x += speed;
}